import React, { useEffect, useState } from "react";
import { BsPlusCircle } from "react-icons/bs";
import Select from "react-select";
import { MultiSelect } from "react-multi-select-component";
import axios from "../../../axios";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { IP } from "./../../../internalServer"
import { useSelector } from "react-redux";

export default function AddMemebersNotice({
  communityDetails,
  setOpenSuccessfull,
  setInAddingMode,
  isAddingModel,
  setAddMemberClick,
  studentLists1,
  teacherLists1,
  setSelectedListStudentClassStateParent,
  selectedStudentListClassStateParent,
  stdParent,
  setStdParent,
  secParent,
  setSecParent,
  addMemberClick
}) {
  const [addMember, setAddMember] = useState({
    activeMember: "Teacher",
    addTeacher: false,
    addGroups: false,
    addStudent: false,
  });
  const { communityId } = useParams();
  const storeStdList = JSON.parse(localStorage.getItem("selectedStudents"));
  const storeTeacherList = JSON.parse(localStorage.getItem("selectedTeachers"));
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  let school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [inProgress, setInProgress] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [selectedStudentListGroupsState, setSelectedListStudentGroupState] =
    useState([]);
  const [studentSectionOptionsState, setStudentSectionOptionsState] =
    useState(null);
  const [selectedStudentListClassState, setSelectedListStudentClassState] =
    useState(selectedStudentListClassStateParent || []);
  const [clicked, setClicked] = useState(true);

  const [optionStudentGroupsState, setOptionStudentGroupsState] =
    useState(null);
  const [studentClassOptionState, setStudentClassOptionState] = useState(null);
  const [sectionDef, setSectionDef] = useState([]);
  const [displayTeacherData, setDisplayTeacherData] = useState([])
  const [teacherList, setTeacherList] = useState([]);
  const [displyaStudentList, setDisplyaStudentList] = useState([])

  const [groupList, setGroupList] = useState([
    {
      label: "Select All",
      value: null,
    },
  ]);
  const allStudentList = useSelector((state) => state.initialData.getAllStudentList);
  const allTeacherList = useSelector((state) => state.initialData.getAllTeacherList)
  const [groupListForStudent, setGroupListForStudent] = useState([]);
  const [studentListByGroup, setStudentListByGroup] = useState([]);
  const [standardDetails, setStandardDetails] = useState({
    standardList: [],
    sectionList: [],
    studentList: [],
  });
  // const { standardList, sectionList, studentList } = standardDetails;
  const [selectedOptions, setSelectedOptions] = useState([]);
  // console.log(sectionList);

  // useEffect(() => {
  //   const getTeachers = async () => {
  //     let res = await axios.get(
  //       `/api/v1/school/teacher/get/school/${school_id}`
  //     );
  //     if (res) {
  //       const teachers = res.data.data
  //         .filter((item) => item.id !== teacher_id)
  //         .map((item, index) => {
  //           return {
  //             label: item.name,
  //             value: item.id,
  //             profilePicture: item.profile_picture,
  //             memberType: "member",
  //           };
  //         });
  //       setTeacherList([...teacherList, ...teachers]);
  //     }
  //   };
  //   getTeachers();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    const getTeachers = async () => {
      try {
        const teacherResponse = await axios.get(`/api/v1/school/teacher/get/school/${school_id}`);
        const teacherData = allTeacherList?.length > 0 ? allTeacherList : teacherResponse?.data?.data;
        if (teacherData) {
          const teachers = teacherData
            .filter((item) => item.id !== teacher_id)
            .map((item) => ({
              label: item.name + " | Code: " + item.code,
              value: item.id,
              code: item.code,
              profilePicture: item.profile_picture,
              gender: item.gender,
              memberType: "member",
            }));

          setTeacherList((prevTeacherList) => [...prevTeacherList, ...teachers]);
        } else {
          console.warn("No teacher data available from allTeacherList or teacherResponse.");
        }
      } catch (error) {
        console.error("Error fetching teacher data:", error);
      }
    };

    getTeachers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    async function fetchDropDowns() {
      // debugger
      // if (stdParent) {
      //   let res = await axios.get(`/api/v1/school/section/get`);
      //   if (res) {
      //     const section = res?.data?.data?.map((item) => {
      //       return {
      //         label: `Section ${item.name}`,
      //         value: item.id,
      //       };
      //     });
      //     section.length > 0 &&
      //       setStandardDetails({
      //         ...standardDetails,
      //         sectionList: section,
      //       });
      //     setSectionDef(section);
      //   }
      // }
      // console.log("stdParent?.value", stdParent.value)
      // console.log("secParent?.value", secParent)
      try {
        if (stdParent?.value && secParent?.value) {
          const studentData =
            allStudentList?.length > 0
              ? allStudentList
              : (await axios.get(`/api/v1/school/student/get/school/${school_id}`)).data?.data;

          if (studentData) {
            const students = studentData
              ?.filter(
                (item) =>
                  item.section.id === secParent?.value && item.standard.id === stdParent?.value
              )
              .map((item) => ({
                label: `${item.name} | Code: ${item.code}`,
                displayLevel: item.name,
                value: item.id,
                code: item.code,
                section: item.section.name,
                standard: item.standard.name,
              }));
            setStandardDetails((prevState) => ({
              ...prevState,
              studentList: students,
            }));
          } else {
            console.warn("No student data found.");
          }
        } else {
          console.warn("Both standard and section must be selected.");
        }
      } catch (error) {
        console.error("Error fetching student data:", error);
      }
    }
    fetchDropDowns();
  }, [stdParent, secParent]);

  const helper = () => {
    studentLists1(selectedStudentListClassState);
    teacherLists1(selectedOptions);
  };
  const getGroupListForStudent = async () => {
    let res = await axios.get(
      `/api/v1/group/filterForTeacher/teacherId/${teacher_id}?_page=1&_limit=20`
    );
    if (res) {
      const groups = res.data.data.map((item, index) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
      setGroupListForStudent(groups);
    }
  };

  const handleGroupSelection = async (selectedOption) => {
    setOptionStudentGroupsState(selectedOption);
    try {
      let res = await axios.get(
        `/api/v1/group/getById/${selectedOption.value}?isFullFledged=true`
      );
      if (res) {
        const student = res?.data?.data?.member.map((item) => {
          return (
            item.member_type === "Student" && {
              label: item.member.name,
              value: item.member.id,
            }
          );
        });

        setStudentListByGroup(student.filter((i) => i !== false));
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (selectedOptions.length > 0) {
      localStorage.setItem(
        "STUDENT_OPTIONS_STORAGE_KEY",
        JSON.stringify(selectedOptions)
      );
    }
  }, [selectedOptions]);
  useEffect(() => {
    const storedStudentOptions = localStorage.getItem(
      "STUDENT_OPTIONS_STORAGE_KEY"
    );
    if (storedStudentOptions) {
      setAddMember({ ...addMember, addTeacher: true });
      setSelectedOptions(JSON.parse(storedStudentOptions));
    }
    if (selectedStudentListClassStateParent) {
      setAddMember({ ...addMember, addStudent: true });
    }
  }, []);
  // const handelStandardSelection = async () => {
  //     setSelectedListStudentGroupState([]);
  //     try {
  //       let res = await axios.get(`/api/v1/school/standard/get`);
  //       if (res) {
  //         const standard = res?.data?.data?.map((item) => {
  //           return {
  //             label: `Class ${item.name}`,
  //             value: item.id,
  //           };
  //         });
  //         setStandardDetails({
  //           ...standardDetails,
  //           standardList: standard,
  //         });
  //       }
  //     } catch (error) {
  //       console.log(error);
  //     }
  // };

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const res = await axios.get(`/api/v1/school/standard/get/school/${school_id}`);
        const standards = res?.data?.data?.map((item) => ({
          label: item.name,
          value: item.id,
        }));

        setStandardDetails((prevState) => ({
          ...prevState,
          standardList: standards,
        }));
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClasses();
  }, [addMemberClick]);

  // const CTRole_Information = JSON.parse(
  //   localStorage.getItem("role_as_class_teacher")
  // );
  // const CoRole_Information = JSON.parse(
  //   localStorage.getItem("role_as_co_ordinator")
  // );
  // const general_role = JSON.parse(localStorage.getItem("general_role"));
  // useEffect(() => {
  //   if (CTRole_Information && CTRole_Information.length > 0) {
  //     CTRole_Information?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (CoRole_Information && CoRole_Information.length > 0) {
  //     CoRole_Information?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   if (general_role && general_role.length > 0) {
  //     general_role?.forEach((obj) => {
  //       if (!standardList.some((i) => i.id === obj.standard_id.id)) {
  //         standardList.push(obj.standard_id);
  //       }
  //       if (!sectionList.some((i) => i.id === obj.section_id.id)) {
  //         sectionList.push(obj.section_id);
  //       }
  //     });
  //   }
  //   standardList.length > 0 &&
  //     setStandardDetails({
  //       ...standardDetails,
  //       standardList,
  //     });

  //   if (sectionList.length > 0) {
  //     setStandardDetails({
  //       ...standardDetails,
  //       sectionList,
  //     });
  //     setSectionDef(sectionList);
  //   }
  // }, []);

  const handelStandardSelectionOption = async (selectedOption) => {
    setStdParent(selectedOption);
    setStudentClassOptionState(selectedOption);

    try {
      const res = await axios.get(`/api/v1/school/section/get/school/${school_id}`);
      const sections = res?.data?.data?.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setStandardDetails((prevState) => ({
        ...prevState,
        sectionList: sections,
      }));
      setSectionDef(sections);
    } catch (error) {
      console.error("Error fetching sections:", error);
    }
  };

  const getStudentListByStandardAndSection = async (selectedOption) => {
    // Update states with selected section
    setStudentSectionOptionsState(selectedOption);
    setSecParent(selectedOption);

    try {
      if (stdParent?.value && selectedOption?.value) {
        const studentData =
          allStudentList?.length > 0
            ? allStudentList
            : (await axios.get(`/api/v1/school/student/get/school/${school_id}`)).data?.data;

        if (studentData) {
          const students = studentData
            ?.filter(
              (item) =>
                item.section.id === selectedOption?.value &&
                item.standard.id === stdParent?.value
            )
            .map((item) => ({
              label: `${item.name} | Code: ${item.code}`,
              displayLevel: item.name,
              value: item.id,
              code: item.code,
              section: item.section.name,
              standard: item.standard.name,
            }));
          setStandardDetails((prevState) => ({
            ...prevState,
            studentList: students,
          }));
        } else {
          console.warn("No student data found.");
        }
      } else {
        console.warn("Both standard and section must be selected.");
      }
    } catch (error) {
      console.error("Error fetching student data:", error);
    }
  };

  const handleAddMember = () => {
    switch (addMember.activeMember) {
      case "Teacher":
        if (selectedOptions.length > 0) {
          setAddMember({ ...addMember, addTeacher: true });
        }
        break;
      case "Group":
        selectedOptionsGoups.length > 0 &&
          setAddMember({ ...addMember, addGroups: true });
        break;
      case "Student":
        (selectedStudentListGroupsState.length > 0 ||
          selectedStudentListClassState.length > 0 ||
          selectedStudentListClassStateParent.length > 0) &&
          setAddMember({ ...addMember, addStudent: true });
        break;
      default:
        // do nothing
        break;
    }
  };

  const DropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "34px",
      width: "127px",
      borderRadius: " 5px",
      fontSize: "12px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: state.selectProps.menuWidth || "auto", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // serch dropdown
  const SearchDropdownStyle = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      border: "none",
      width: "35vw",
      borderRadius: " 5px",
      fontSize: "16px",
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "35vw",
      padding: "10px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      color: "#F77F00", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        marginRight: "10px",
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      display: "none",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for teahcer
  const ClassOptions = [
    { value: "admin", label: "Admin" },
    { value: "moderator", label: "Moderator" },
    { value: "member", label: "Member" },
  ];
  const [selectedClass, setSelectedClass] = useState({
    value: "member",
    label: "Member",
  });

  const Option = (props) => {
    const { data, isSelected, innerRef, selectProps } = props;

    let isChecked = isSelected;
    if (data.value === null) {
      isChecked = selectProps.value.length === teacherList.length - 1;
    }

    return (
      <div
        ref={innerRef}
        className={`option ${isSelected ? "selected" : ""}`}
        onClick={() => props.selectOption(props.data)}
      >
        <input
          type="checkbox"
          checked={isChecked}
          readOnly
          style={{ marginRight: "8px" }}
        />
        <span style={{ color: "#000000", fontSize: "14px", cursor: "pointer" }}>
          {data.label}
        </span>
      </div>
    );
  };
  const [selectedTeacherOptions, setSelectedTeacherOptions] = useState([]);

  const handleOptionChange = (selectedOptions) => {
    setAddMember({ ...addMember, addTeacher: false });
    if (selectedOptions?.some((option) => option?.value === null)) {
      setSelectedOptions(teacherList.slice(1));
    } else {
      for (let i of selectedOptions) {
        i.memberType = selectedClass.value;
      }
      setSelectedOptions(selectedOptions);
      setSelectedTeacherOptions(selectedOptions);
      localStorage.setItem(
        "TEACHER_OPTIONS_STORAGE_KEY",
        JSON.stringify(selectedOptions)
      );
    }
  };
  const [show, setShow] = useState(false);
  useEffect(() => {
    const storedTeacherOptions = localStorage.getItem(
      "TEACHER_OPTIONS_STORAGE_KEY"
    );
    let res = JSON.parse(storedTeacherOptions);
    if (res.length > 0) {
      setAddMember({
        ...addMember,
        addTeacher: true,
      });
      setSelectedTeacherOptions(JSON.parse(storedTeacherOptions));
      setSelectedOptions(JSON.parse(storedTeacherOptions));
      // setAddMember({...addMember,addTeacher:true})
    }
  }, []);

  const handelHeaderSelectOption = (selectedOption) => {
    setSelectedClass(selectedOption);
    for (let i of selectedOptions) {
      i.memberType = selectedOption.value;
    }
    setSelectedOptions(selectedOptions);
  };
  const handelChangePurticularMemberType = (e, id) => {
    setSelectedOptions((prevOptions) => {
      const newOptions = [...prevOptions];
      const index = newOptions.findIndex((option) => option.value === id);
      if (index !== -1) {
        newOptions[index].memberType = e.value;
      }
      return newOptions;
    });
  };

  // this css for student class
  const DropdownStyleStudentsClass = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "231px",

      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "200px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  // code for Groups
  const DropdownStyleStudents = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#99ADBB",
      height: "30px",
      width: "350px",
      borderRadius: " 5px",
      fontSize: "12px",
      // border: 'none',
      boxShadow: state.isFocused ? null : null,
    }),
    menu: (provided, state) => ({
      ...provided,
      width: "305px", // Set the width to 10px when menuWidth is set
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white",
      fontSize: "12px",
      color: "black", // Change the background color when the option is hovered over
      "&:hover": {
        boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)",
        color: "#F77F00",
        borderRadius: "5px",
        fontWeight: "600",
      },
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const [selectedOptionsGoups, setSelectedOptionsGoups] = useState([]);

  const handleOptionChangeGroups = (selectedOptionsGoups) => {
    if (selectedOptionsGoups.some((option) => option.value === null)) {
      setSelectedOptionsGoups(groupList.slice(1));
    } else {
      setSelectedOptionsGoups(selectedOptionsGoups);
    }
  };
  useEffect(() => {
    if (addMember.addTeacher === true || addMember.addStudent === true) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  }, [addMember]);

  const handelSubmit = async (e) => {
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }
    if (
      selectedStudentListClassState &&
      selectedStudentListClassState.length > 0
    ) {
      let students = selectedStudentListClassState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }
    if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }

    if (selectedOptions && selectedOptions.length > 0) {
      let teachers = selectedOptions.map((teacher) => {
        return { id: teacher.value, role: teacher.memberType };
      });
      members.push({ teachers: teachers });
    }

    let newCommunity = {
      user_id: teacher_id,
      community_name: communityDetails.name,
      short_description: communityDetails.description,
      members,
    };

    if (communityDetails.profilePicture) {
      const formData = new FormData();
      formData.append("name", communityDetails.profilePicture.name);
      formData.append(
        "uploadCommunityAttachment",
        communityDetails.profilePicture
      );
      try {
        const res = await axios.post(
          `/api/v1/community/uploadAttachment/teacherId/${teacher_id}`,
          formData
        );
        newCommunity.profile_picture = res.data.data;
      } catch (error) { }
    }
    try {
      let res = await axios.post(`/api/v1/community/create`, newCommunity);
      res && setInProgress(false);
      setOpenSuccessfull(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handelAddMemberInExisting = async (e) => {
    setInProgress(true);
    setIsValid(true);
    let members = [];
    if (selectedOptionsGoups && selectedOptionsGoups.length > 0) {
      let groups = selectedOptionsGoups.map((group) => {
        return group.value;
      });
      members.push({ groups: groups });
    }
    if (
      selectedStudentListClassStateParent &&
      selectedStudentListClassStateParent.length > 0
    ) {
      let students = selectedStudentListClassStateParent.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    } else if (
      selectedStudentListGroupsState &&
      selectedStudentListGroupsState.length > 0
    ) {
      let students = selectedStudentListGroupsState.map((student) => {
        return student.value;
      });
      members.push({ students: students });
    }
    if (selectedOptions && selectedOptions.length > 0) {
      let teachers = selectedOptions.map((teacher) => {
        return { id: teacher.value, role: teacher.memberType };
      });
      members.push({ teachers: teachers });
    }
    let newMembers = {
      user_id: teacher_id,
      members,
    };
    try {
      let res = await axios.post(
        `/api/v1/community/addMember/${communityId}`,
        newMembers
      );
      res && setInProgress(false);
      setOpenSuccessfull(true);
    } catch (error) {
      console.log(error);
    }
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  //This method use of prevent the double api call
  // const debounce = (func, delay) => {
  //   let timeout;
  //   return (...args) => {
  //     clearTimeout(timeout);
  //     timeout = setTimeout(() => func(...args), delay);
  //   };
  // };

  // const debouncedSetSecParent = debounce(setSecParent, 300);
  return (
    <>
      <div className="BigRelative">
        <div className="RelativeContainer">
          <div className="addMemberHeader1 mb-4">Create New Notice</div>
          <div className="addMemberHeader ml-3">Add Members</div>
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div className="d-flex gap-3 mt-2">
              <button
                onClick={(e) =>
                  setAddMember({ ...addMember, activeMember: "Teacher" })
                }
                className={`${addMember.activeMember === "Teacher"
                  ? "active addMemberBtns_active"
                  : "addMemberBtns"
                  }`}
              >
                Teacher
              </button>
              <button
                onClick={(e) => {
                  setAddMember({ ...addMember, activeMember: "Student" });
                  getGroupListForStudent();
                  // handelStandardSelection();
                }}
                className={` ${addMember.activeMember === "Student"
                  ? "active addMemberBtns_active"
                  : "addMemberBtns"
                  }`}
              >
                Student
              </button>
            </div>

            {/* {
              <div>
                <button onClick={handleAddMember} className="addMemberAddBtns">
                  <BsPlusCircle />
                  &nbsp; Add
                </button>
              </div>
            } */}
          </div>
          {addMember.activeMember === "Teacher" && (
            <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
              <div style={{ maxWidth: "300px", flex: 1 }}>
                <MultiSelect
                  options={teacherList}
                  value={selectedOptions}
                  onChange={(selectedOptions) => {
                    handleOptionChange(selectedOptions)
                    let displayTeacherList = selectedOptions.map((val) => {
                      return {
                        label: val.label,
                        value: val.value,
                        code: val.code,
                        memberType: val.memberType,
                        gender: val.gender,
                        profilePicture: val.profilePicture
                      }
                    })
                    // Avoid duplicates in display data
                    setDisplayTeacherData((prev) => {
                      const combinedDisplayData = [...prev];
                      displayTeacherList.forEach((teacher) => {
                        if (!combinedDisplayData.some((item) => item.value === teacher.value)) {
                          combinedDisplayData.push(teacher);
                        }
                      });

                      // Remove teacher that have been unchecked (not in selectedOption)
                      const finalDisplayData = displayTeacherList.filter((teacher) =>
                        selectedOptions.some((selected) => selected.value === teacher.value)
                      );
                      localStorage.setItem("selectedTeachers", JSON.stringify(finalDisplayData))
                      return finalDisplayData;
                    });
                    setClicked(true);
                  }}
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={SearchDropdownStyle}
                  selected={true}
                  width={160}
                />
              </div>

              {/* <div>
              <Select
                styles={DropdownStyle}
                options={ClassOptions}
                value={selectedClass}
                onChange={(selectedOption) =>
                  handelHeaderSelectOption(selectedOption)
                }
                placeholder="Select"
                menuWidth={127}
              />
            </div> */}
            </div>
          )}

          {addMember.activeMember === "Student" && (
            <div className="mt-2">
              <div className="d-flex flex-wrap gap-3">
                {/* <div className="gap-2 ">
                <input
                  onClick={(e) => {
                    setActiveRadio("Groups");
                    // setSelectedListStudentClassState([]);
                  }}
                  className="mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="option1"
                  checked={activeRadio === "Groups"}
                />
                <label className="radioBtn_css">Groups</label>
              </div> */}
                {/* <div>
                <input
                  onClick={(e) => {
                    setActiveRadio("Class");
                    handelStandardSelection();
                  }}
                  className="mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="option2"
                  checked={activeRadio === "Class"}
                />
                <label className="radioBtn_css">Classes</label>
              </div> */}
              </div>
              <div className="Container_bothDropdowns">
                {/* {activeRadio === "Groups" ? (
                  <div className="d-flex gap-1" >
                    <div>
                      <Select
                        styles={DropdownStyleStudents}
                        options={groupListForStudent}
                        value={optionStudentGroupsState}
                        onChange={(selectedOption) =>
                          handleGroupSelection(selectedOption)
                        }
                        placeholder="Select Group"
                      />
                    </div>
                    <div>
                      <MultiSelect
                        options={studentListByGroup}
                        value={selectedStudentListGroupsState}
                        onChange={setSelectedListStudentGroupState}
                        className="custom-multiselect"
                        labelledBy={"Select"}
                        overrideStrings={{ selectSomeItems: "Select Students" }}
                      />
                    </div>
                  </div>
                ) :  */}
                <div className="d-flex flex-wrap gap-1">
                  <div>
                    <Select
                      styles={DropdownStyleStudentsClass}
                      options={standardDetails?.standardList}
                      value={stdParent}
                      onChange={(selectedOption) => {
                        handelStandardSelectionOption(selectedOption);
                        setSecParent(null);
                      }}
                      placeholder="Select Class"
                    />
                  </div>
                  <div>
                    <Select
                      styles={DropdownStyleStudentsClass}
                      options={sectionDef}
                      value={secParent}
                      onChange={(selectedOption) => {
                        setSecParent(selectedOption);
                        getStudentListByStandardAndSection(selectedOption)
                      }
                      }
                      placeholder="Select Section"
                      menuWidth={127}
                    />
                  </div>
                  <div>
                    <MultiSelect
                      options={standardDetails?.studentList}
                      value={selectedStudentListClassStateParent}
                      onChange={(selectedOption) => {
                        setSelectedListStudentClassState(selectedOption);
                        setSelectedListStudentClassStateParent(selectedOption);
                        const displayStudentList = selectedOption.map((val) => ({
                          label: val.displayLevel,
                          value: val.value,
                          code: val.code,
                          section: val.section,
                          standard: val.standard,
                        }));

                        setDisplyaStudentList((prev) => {
                          // Start with previous display data
                          const combinedDisplayData = [...prev];

                          // Add any new unique students from displayStudentList
                          displayStudentList.forEach((student) => {
                            if (!combinedDisplayData.some((item) => item.value === student.value)) {
                              combinedDisplayData.push(student);
                            }
                          });

                          displayStudentList.forEach((student) => {
                            if (!combinedDisplayData.some((item) => item.value === student.value)) {
                              combinedDisplayData.push({
                                label: student.displayLevel,
                                value: student.value,
                                code: student.code,
                                section: student.section,
                                standard: student.standard,
                              });
                            }
                          })

                          // console.log("combinedDisplayData2", combinedDisplayData)


                          const valueSet = new Set(combinedDisplayData.map((student) => student.value));
                          const finalDisplayDataList = [
                            ...combinedDisplayData,
                            ...selectedOption.filter((selected) => !valueSet.has(selected.value))
                          ];
                          // console.log("finalDisplayDataList", finalDisplayDataList)
                          // Filter out students that have been unchecked

                          const finalDisplayData = finalDisplayDataList.filter(
                            (student) => selectedOption.some((selected) => selected.value !== student.value)
                          );
                          localStorage.setItem("selectedStudents", JSON.stringify(finalDisplayData))
                          return finalDisplayData;
                        });

                        setAddMember({ ...addMember, addStudent: false });
                      }}
                      className="custom-multiselectNew"
                      labelledBy={"Select"}
                      overrideStrings={{ selectSomeItems: "Select Students" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {addMember.activeMember === "Group" && (
            <div className="Container_bothDropdowns d-flex justify-content-between align-items-center mt-3">
              <div style={{ maxWidth: "300px", flex: 1 }}>
                <Select
                  options={groupList}
                  value={selectedOptionsGoups}
                  onChange={handleOptionChangeGroups}
                  placeholder="Type here to search..."
                  isClearable
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  styles={SearchDropdownStyle}
                />
              </div>
            </div>
          )}

          <div className="Total_container_addedmember" style={{ marginTop: "20px", maxHeight: "280px" }}>
            {/* TEACHERS */}
            <div>
              {addMember.activeMember && (
                <div className="">
                  <div className="addedMember">Added Members</div>
                  {selectedOptions?.length > 0 && (<div className="teacher_header mt-2">TEACHERS</div>)}
                  <div className="teachersName">
                    {
                      (displayTeacherData.length > 0 ? displayTeacherData : storeTeacherList)?.map((item) => {
                        return (
                          <div className="d-flex">
                            <div
                              key={item.id}
                              className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                            >
                              <div className=" d-flex justify-content-center">
                                <div className="">
                                  {/* {item.label.substr(0, 1)} */}
                                  <img
                                    src={
                                      item?.profile_picture
                                        ? IP + item?.profile_picture.replace(/^\./, "")
                                        : item?.gender === "M"
                                          ? "/images/Teacher_Male.jpg"
                                          : item?.gender === "F"
                                            ? "/images/Teacher_Female.png"
                                            : "/images/default-profile.png"
                                    }
                                    alt='icon'
                                    className="profilePicImg"
                                    style={{ width: "23px", height: "23px", borderRadius: "50%" }}
                                    onError={(e) => {
                                      if (item?.gender === "M") {
                                        e.target.src = "/images/Teacher_Male.jpg";
                                      } else if (item?.gender === "F") {
                                        e.target.src = "/images/Teacher_Female.png";
                                      } else {
                                        e.target.src = "/images/default-profile.png"
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="names_tacher">
                                <div>{item.label}</div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                    {/* {addMember.addTeacher &&
                      selectedOptions.map((option) => (
                        <div className="d-flex">
                          <div
                            key={option.id}
                            className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                          >
                            <div className="teachersNameImg d-flex justify-content-center">
                              <div className="NamesFirstLetter">
                                {option.label.substr(0, 1)}
                              </div>
                            </div>
                            <div className="names_tacher">
                              <div>{option.label}</div>
                            </div>
                          </div>

                          <div>
                            <div className="mt-1">
                              <Select
                                styles={DropdownStyle}
                                options={ClassOptions}
                                value={{
                                  value: option.memberType,
                                  label: option.memberType,
                                }}
                                onChange={(e) =>
                                  handelChangePurticularMemberType(
                                    e,
                                    option.value
                                  )
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))} */}
                  </div>
                </div>
              )}
            </div>

            {/* student  */}
            <div className="mt-1">
              {addMember.activeMember && (
                <div>
                  <div>
                    {(selectedStudentListClassState?.length > 0) && <div className="teacher_header">STUDENTS</div>
                    }
                    <div>
                      {
                        (displyaStudentList.length > 0 ? displyaStudentList : storeStdList)?.map((student) => {
                          return (
                            <div
                              key={student.id}
                              className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                            >
                              <div className="teachersNameImg d-flex justify-content-center">
                                <div className="NamesFirstLetter">
                                  {student?.label?.substr(0, 1)}
                                </div>
                              </div>
                              <div className="names_tacher">
                                {/* Display student info on UI */}
                                <div>{student?.label} {" | " + student?.standard} | {student?.section} | {"Roll Code: " + student?.code}</div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>

                  <div>
                    {/* {selectedStudentListGroupsState.map((option) => (
                  <div
                    key={option.id}
                    className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                  >
                    <div className="teachersNameImg d-flex justify-content-center">
                      <div className="NamesFirstLetter">
                        {option.label.substr(0, 1)}
                      </div>
                    </div>
                    <div className="names_tacher">
                      <div>{option.label}</div>
                    </div>
                  </div>
                ))} */}

                    {/* {selectedStudentListClassState.map((option) => (
                    <div
                      key={option.id}
                      className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                    >
                      <div className="teachersNameImg d-flex justify-content-center">
                        <div className="NamesFirstLetter">
                          {option.label.substr(0, 1)}
                        </div>
                      </div>
                      <div className="names_tacher">
                        <div>{option.label}</div>
                      </div>
                    </div>
                  ))} */}
                  </div>
                </div>
              )
              }
            </div>

            {/* GROUPS  */}
            <div className="mt-1">
              {addMember.addGroups && (
                <div>
                  <div className="teacher_header">GROUPS</div>

                  <div>
                    {selectedOptionsGoups.map((option) => (
                      <div
                        key={option.id}
                        className="d-flex gap-2 mt-2 align-itmes-center w-100 "
                      >
                        <div className="teachersNameImg d-flex justify-content-center">
                          <div className="NamesFirstLetter">
                            {option.label.substr(0, 1)}
                          </div>
                        </div>
                        <div className="names_tacher">
                          <div>{option.label}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="absoluteContainer w-100" >

            {!isAddingModel ? (
              <div className="innerFlexContainer w-100" >
                <div className="d-flex gap-4" style={{ marginTop: "127px" }}>
                  <button
                    onClick={(e) => {
                      setAddMemberClick((prev) => !prev);
                    }}
                    className="Previous_Btn_channel"
                  >
                    Previous
                  </button>
                  {/* {!inProgress ? (
                    
                  ) : (
                    <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
                  )} */}
                  <button
                    type="submit"
                    // disabled={isValid}
                    onClick={() => {
                      helper();
                      setAddMemberClick((prev) => !prev);
                    }}
                    className="Previous_Btn_channel"
                  >
                    Save
                  </button>
                </div>
              </div>
            ) : (
              <div className="d-flex justify-content-end">
                <div className="d-flex gap-4">
                  <button
                    onClick={(e) => {
                      setInAddingMode(!isAddingModel);
                    }}
                    className="Previous_Btn_channel"
                  >
                    Discard
                  </button>
                  {!inProgress ? (
                    <button
                      type="submit"
                      disabled={isValid}
                      onClick={(e) => handelAddMemberInExisting(e)}
                      className="btn btn-danger create_Btn"
                    >
                      Save
                    </button>
                  ) : (
                    <img className="Loader" src="/gif/LoaderDot.gif" alt="" />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
